import React, {useContext, useState, useEffect} from 'react';
import styles from '../AuthForms.module.sass';
import cn from 'classnames';
import { ConquerContext } from '../../../contexts/ConquerContext';
import { AUTH_ZONE } from '..';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Loader from '../../LoaderCircle';
import PasswordInput from '../../PasswordInput';

const PasswordRecoverForm = ({ onFinishCallback, customEmail }) => {

    const conquer = useContext( ConquerContext );

    const [waitingForCode, setWaitingForCode] = useState( customEmail ? true : false );

    //First Step
    const [email, setEmail] = useState( '' );
    
    //Second Step
    const [verificationCode, setVerificationCode] = useState( '' );
    const [password, setPassword] = useState( '' );
    const [repeatPassword, setRepeatPassword] = useState( '' );
    
    const [error, setError] =  useState( '' );
    const [sendTimer, setSendTimer] = useState( 0 );
    const [isLoading, setIsLoading] = useState( false );

    //Swap logic:

    const buttonCallback = waitingForCode ? tryToChangePassword : tryToRequestPasswordReset;
    const buttonText = waitingForCode ? 'Change Password' : 'Send Email' ;
    
    function showError( message ){
        
        setError( message );
        return false;
        
    }

    async function tryToRequestPasswordReset(){

        if( !/\S+@\S+\.\S+/.test(customEmail || email) ) return showError( 'The email doesnt have a valid format' );

        setError('');
        setIsLoading( true );
        let response = await conquer.Auth.sendResetPassword( {email: customEmail || email} );
        setIsLoading( false );
        
        if( response.error ) return showError( response.error );
        
        setError('');
        setWaitingForCode( true );

    }
    
    async function tryToSendVerificationCode(){

        if( sendTimer != 0 ) return showError( 'Please wait a bit to send a new code.' );

        setSendTimer( 10 );

        setError('');
        setIsLoading( true );
        let response = await conquer.Auth.resendResetKey( {email: customEmail || email} );
        setIsLoading( false );

        if( response.error ) return showError( response.error );

    }

    async function tryToChangePassword(){

        if( !verificationCode || verificationCode.length != 4 ) return showError( 'You have to provide a valid verification code.' );
        if( !password || password.length < 8 || password.length > 16 ) return showError( 'You need to provide a valid password. Min 8 chars and max 16 chars' );
        if( password != repeatPassword ) return showError( 'The password doesnt match' );

        setError('');
        setIsLoading( true );
        let response = await conquer.Auth.changePassword( { email: customEmail || email, password: password, resetKey: verificationCode } );
        console.log( response );
        setIsLoading( false );

        if(  response.error ) return showError( response.error );

        onFinishCallback();

    }

    function updateSendTimer(){

        let newTime = sendTimer - 1;
        if( newTime < 0 ) newTime = 0; 
        setSendTimer( newTime );

    }

    useEffect(() => {
        let interval;
        if( sendTimer > 0) interval = setInterval(updateSendTimer, 1000);
    
        return () => {if( interval ) clearInterval(interval)};
    }, [sendTimer]);

    useEffect( () => {
        async  function logic(){
            if( !customEmail ) return;
            await tryToRequestPasswordReset();
            await tryToSendVerificationCode();
        }
        logic();
    }, [conquer.initialized]);

    return (
        <div className={'form'}>
            <div className={styles.form__column}>
                {
                    (
                        !waitingForCode ?                 
                    <div className={'fields_container'}>
                        <input
                                type='email'
                                placeholder='Email'
                                className={styles.form__input}
                                value={email}
                                onChange={(event) => {setEmail(event.target.value)}}
                            />
                    </div>
                    :
                    <div className={'fields_container'}>
                        <input
                            type='text'
                            placeholder='Code'
                            className={error && !isLoading ? 'error' : ''}
                            max='4'
                            min='4'
                            value={verificationCode}
                            onChange={(event) => { setVerificationCode(event.target.value) }}
                        />
                        <PasswordInput
                            placeholder='Password'
                            onValueChange={(value) => {setPassword(value)}}
                            error={error && !isLoading}
                        />
                        <PasswordInput
                            placeholder='Repeat Password'
                            onValueChange={(value) => {setRepeatPassword(value)}}
                            error={error && !isLoading}
                        />
                        <div className={styles.form_bottom}>
                            <button className='helperLink' onClick={tryToSendVerificationCode}>Send Again {sendTimer > 0 && <span>({sendTimer}s)</span>} </button>
                        </div>
                    </div>
                    )
                }
                { isLoading ? 
                    <Loader /> : 
                    <div className={styles.form__btn}>
                        <button className={cn('button', 'primary')} onClick={ buttonCallback }>
                            {buttonText}
                        </button>
                    </div>
                }
                {error && <p className={'error'}>{error}</p>}
            </div>
        </div>
    );
};

export default PasswordRecoverForm;
